import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row g-3 mb-4" }
const _hoisted_3 = { class: "col-12 col-md-6 col-lg-3" }
const _hoisted_4 = { class: "col-12 col-md-6 col-lg-9" }
const _hoisted_5 = { class: "row g-3 mb-4 align-items-stretch" }
const _hoisted_6 = { class: "col-9" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "row g-3" }
const _hoisted_9 = { class: "col-12 col-md-6 col-lg-4" }
const _hoisted_10 = { class: "col-12 col-md-6 col-lg-4" }
const _hoisted_11 = { class: "col-12 col-md-6 col-lg-4" }

import { onMounted, onUnmounted } from "vue";
import AutoCreatePermission from "./DashboardComp/AutoCreatePermission/AutoCreatePermission.vue";
import DevicesAndUsers from "./DashboardComp/DevicesAndUsers/DevicesAndUsers.vue";
import DealingOnline from "./DashboardComp/DealingOnline/DealingOnline.vue";
import EmailCheck from "../components/EmailCheck.vue";
import RebateInfo from "./DashboardComp/RebateInfo/RebateInfo.vue";
import ReportStatus from "./DashboardComp/ReportStatus/ReportStatus.vue";
import TractionCheck from "./DashboardComp/Traction/TractionCheck.vue";

// 响应式侧边栏折叠功能

export default /*#__PURE__*/_defineComponent({
  __name: 'TenantDashboard',
  setup(__props) {

const handleSidebarCollapse = () => {
  const screenWidth = window.innerWidth;
  const sidebarElement = document.querySelector("#kt_app_sidebar");

  if (screenWidth < 1280) {
    // 屏幕宽度小于1280px时折叠侧边栏
    document.body.setAttribute("data-kt-app-sidebar-minimize", "on");
    if (sidebarElement) {
      sidebarElement.classList.add("app-sidebar-minimize");
    }
  } else {
    // 屏幕宽度大于等于1280px时展开侧边栏
    document.body.setAttribute("data-kt-app-sidebar-minimize", "off");
    if (sidebarElement) {
      sidebarElement.classList.remove("app-sidebar-minimize");
    }
  }
};

onMounted(() => {
  // 初始化时检查屏幕宽度
  handleSidebarCollapse();

  // 监听窗口大小变化
  window.addEventListener("resize", handleSidebarCollapse);
});

onUnmounted(() => {
  // 清理事件监听器
  window.removeEventListener("resize", handleSidebarCollapse);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$can('TenantAdmin'))
          ? (_openBlock(), _createBlock(AutoCreatePermission, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.$can('TenantAdmin'))
              ? (_openBlock(), _createBlock(DevicesAndUsers, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.$can('SuperAdmin'))
              ? (_openBlock(), _createBlock(DealingOnline, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.$can('TenantAdmin'))
          ? (_openBlock(), _createBlock(TractionCheck, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.$can('TenantAdmin'))
          ? (_openBlock(), _createBlock(RebateInfo, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.$can('TenantAdmin'))
          ? (_openBlock(), _createBlock(ReportStatus, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.$can('TenantAdmin'))
          ? (_openBlock(), _createBlock(EmailCheck, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})